import type React from "react";
import { useEffect, useRef } from "react";

interface GroundMapProps {
  coordinates: [number, number];
  name: string;
  address: string;
  className?: string;
}

const GroundMap: React.FC<GroundMapProps> = ({ coordinates, name, address, className = "" }) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<google.maps.Map | null>(null);

  useEffect(() => {
    if (!mapRef.current || !window.google) return;

    const map = new window.google.maps.Map(mapRef.current, {
      center: { lat: coordinates[1], lng: coordinates[0] },
      zoom: 15,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    const marker = new window.google.maps.Marker({
      position: { lat: coordinates[1], lng: coordinates[0] },
      map,
      title: name,
    });

    const infoWindow = new window.google.maps.InfoWindow({
      content: `
        <div class="p-2">
          <h3 class="font-semibold">${name}</h3>
          <p class="text-sm text-gray-600">${address}</p>
        </div>
      `,
    });

    marker.addListener("click", () => {
      infoWindow.open(map, marker);
    });

    mapInstanceRef.current = map;

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current = null;
      }
    };
  }, [coordinates, name, address]);

  return (
    <div className={`map-container ${className}`}>
      <div ref={mapRef} className='h-full w-full rounded-lg' />
    </div>
  );
};

export default GroundMap;
